export const hashParamsAndBody = ({ params = {}, data = {} }) => {
  const input = JSON.stringify({ params, data });
  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // Convert to 32bit int
  }

  return Math.abs(hash).toString();
};